const PROJECT_NAMESPACE = "wk";

export default PROJECT_NAMESPACE;
